export default __webpack_public_path__ + "static/wallet-aa9c69c0b655305799975f6b2651dd64.png";